import { Directive, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { MatLegacyAutocomplete as MatAutocomplete } from "@angular/material/legacy-autocomplete";
import { Logger } from "@timeghost/web-api";
import { Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";

const log = new Logger("OptionsScrollDirective");

export interface IAutoCompleteScrollEvent {
	autoComplete: MatAutocomplete;
	scrollEvent: Event;
}

@Directive({
	selector: "mat-autocomplete[optionsScroll]",
})
export class OptionsScrollDirective implements OnDestroy {
	@Input() thresholdPercent = 0.8;
	@Output("optionsScroll") scroll = new EventEmitter<IAutoCompleteScrollEvent>();
	_onDestroy = new Subject<void>();

	constructor(private autoComplete: MatAutocomplete) {
		this.autoComplete.opened
			.pipe(
				tap(() => {
					log.debug("auc opened");
					// Note: When autocomplete raises opened, panel is not yet created (by Overlay)
					// Note: The panel will be available on next tick
					// Note: The panel wil NOT open if there are no options to display
					setTimeout(() => {
						// Note: remove listner just for safety, in case the close event is skipped.
						log.debug("binding scroll");
						this.removeScrollEventListener();
						if (this.autoComplete && this.autoComplete.panel) {
							this.autoComplete.panel.nativeElement.addEventListener("scroll", this.onScroll.bind(this));
						}
					});
				}),
				takeUntil(this._onDestroy)
			)
			.subscribe();

		this.autoComplete.closed
			.pipe(
				tap(() => this.removeScrollEventListener()),
				takeUntil(this._onDestroy)
			)
			.subscribe();
	}

	private removeScrollEventListener() {
		if (this.autoComplete && this.autoComplete.panel && this.autoComplete.panel.nativeElement) {
			this.autoComplete.panel.nativeElement.removeEventListener("scroll", this.onScroll);
		}
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();

		this.removeScrollEventListener();
	}

	onScroll(event: Event) {
		if (this.thresholdPercent === undefined) {
			this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
		} else {
			// @ts-ignore
			const threshold = (this.thresholdPercent * 100 * event.target.scrollHeight) / 100;
			// @ts-ignore
			const current = event.target.scrollTop + event.target.clientHeight;

			log.debug(`scroll ${current}, threshold: ${threshold}`);
			if (current > threshold) {
				log.debug("load next page");
				this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
			}
		}
	}
}
